import { err, Result } from "neverthrow";
import { DomainError } from "@/lib/api/domain-error";
import type { RequestFn } from "@/lib/api/types";
import { AccountSubscriptionModel } from "./models";

const ACCOUNT_SUBSCRIPTION_ROUTE_V1 = "/v1/account-subscriptions";

export default class AccountSubscriptionRepository {
  constructor(private readonly request: RequestFn) {}

  async getAll(
    accountSlug: string,
  ): Promise<Result<AccountSubscriptionModel[], DomainError>> {
    try {
      const url = `${ACCOUNT_SUBSCRIPTION_ROUTE_V1}/${accountSlug}`;
      const apiResult = await this.request({
        url,
        method: "Get",
      });

      return apiResult.map((domainData: any) =>
        domainData.data.map((subs: AccountSubscriptionModel) => {
          return {
            id: subs.id,
            planId: subs.planId,
            status: subs.status,
            startedAt: subs.startedAt ? new Date(subs.startedAt) : undefined,
            expiresAt: subs.expiresAt ? new Date(subs.expiresAt) : null,
            planSnapshot: subs.planSnapshot,
            availableAddons: subs.availableAddons || [],
            createdAt: subs.createdAt ? new Date(subs.createdAt) : undefined,
            updatedAt: subs.updatedAt ? new Date(subs.updatedAt) : undefined,
          };
        }),
      );
    } catch (error) {
      return err(new DomainError(error));
    }
  }

  // async create(
  //   accountSlug: string,
  //   planId: string,
  // ): Promise<Result<void, DomainError>> {
  //   try {
  //     const url = `${ACCOUNT_SUBSCRIPTION_ROUTE_V1}/${accountSlug}`;
  //     const apiResult = await this.request({
  //       url,
  //       method: "Post",
  //       data: {
  //         planId,
  //       },
  //     });

  //     return apiResult.map((domainData: any) => {
  //       return domainData.data;
  //     });
  //   } catch (error) {
  //     return err(new DomainError(error));
  //   }
  // }

  // async updateStatus(
  //   subscriptionId: string,
  //   status: string,
  // ): Promise<Result<void, DomainError>> {
  //   try {
  //     const url = `${ACCOUNT_SUBSCRIPTION_ROUTE_V1}/${subscriptionId}/update-status`;
  //     const apiResult = await this.request({
  //       url,
  //       method: "Patch",
  //       data: {
  //         status: status,
  //       },
  //     });

  //     return apiResult.map((domainData: any) => {
  //       return domainData.data;
  //     });
  //   } catch (error) {
  //     return err(new DomainError(error));
  //   }
  // }
}
